customElements.define('component-country-selector', class CountrySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // DOM Elements
    this.countryCode = document.querySelector('input[name="country_code"]');
    this.select = document.querySelector('.js-component-country-selector__select');
    this.dropdown = document.querySelector('.js-component-country-selector-dropdown');
    this.dropdownMenu = document.querySelector('.js-component-country-selector-dropdown-menu');
    this.dropdownLabel = document.querySelector('.js-component-country-selector-dropdown-label');
    this.dropdownLabel.textContent = window.Shopify.country === 'CA' ? 'Canada' : 'United States';

    // Events
    this.dropdown.addEventListener('click', () => {
      this.dropdownMenu.classList.toggle('component-country-selector__hidden');
    });
    this.select.addEventListener('change', (event) => {
      this.submitForm(event, this.select.value);
    });
    this.querySelectorAll('.js-option').forEach(option => {
      option.addEventListener('click', (event) => {
        this.submitForm(event, event.currentTarget.dataset.value);
      });
    });
  }

  submitForm(event, value) {
    event.preventDefault();
    const domain = window.location.host.includes('trythirdlove') ? 'trythirdlove.com' : 'thirdlove.com';
    const form = this.querySelector('form');
    this.countryCode.value = value;
    jsCookie.remove('_tl_changed_location');
    jsCookie.set('_tl_changed_location', true, { expires: 1, domain });
    jsCookie.set('_tl_localization', value, { expires: 1, domain });
    if (form) {
      form.submit();
    }
  }
});
